<template lang="pug">
  .component-create-entity-button
    ModalReveal(:ref="`maintenance-${_uid}`", :id="`maintenance-${_uid}`", @input="close")
      button.button.success(slot="trigger", v-if="request", @click="open") Edit
      a.fa-stack.fa-lg(slot="trigger", v-else)
        i.fa.fa-circle.fa-stack-2x
        i.fa.fa-plus.fa-stack-1x.fa-inverse
      h2 Update intervention request {{request.id}}
      InterventionRequestForm(v-model="body", :sub-request="request.linked_intervention_request_id !== null", :edit="true")
      ActionButton(slot="footer", :action="save") Save
      button.button.alert.float-right(slot="footer", @click="close(false)") Cancel
</template>

<script>
import DatePicker from '../../components/structure/DatePicker'
import ModalReveal from '../../components/structure/foundation/ModalReveal'
import KeplerBackofficeSdk from '../../lib/kepler/backoffice'
import ActionButton from '../../components/structure/ui/ActionButton'
import SelectizeVehicle from "../../components/structure/ui/lists/selectize/SelectizeVehicle.vue";
import InterventionRequestForm from "../../components/structure/forms/InterventionRequestForm.vue";
import {EventBus} from "../../eventBus";

export default {
  name: 'EditInterventionRequestReveal',
  components: {InterventionRequestForm, SelectizeVehicle, ActionButton, ModalReveal, DatePicker},
  data() {
    return {
      body: {}
    }
  },
  created() {

  },
  methods: {
    open() {
      this.body = {
        status: this.request.status,
        linked_intervention_request_id: this.request.linked_intervention_request_id,
        maintenance_driver_id: this.request.hasOwnProperty('driver') && this.request.driver ? this.request.driver.id : null,
        vehicle_id: this.request.hasOwnProperty('vehicle') && this.request.vehicle ? this.request.vehicle.id : null,
        priority: this.request.priority,
        type: this.request.type,
        description: this.request.description,
        start_at: this.request.start_at,
        expiry: this.request.expiry,
        has_linked_requests: this.request.has_linked_requests,
      }
    },
    save() {
      if (!Number.isInteger(this.body.linked_intervention_request_id) && this.body.linked_intervention_request_id !== null) {
        this.body.linked_intervention_request_id = this.body.linked_intervention_request_id.id
      }
      return KeplerBackofficeSdk.maintenanceRequest.select(this.request).update(this.body, () => {
        EventBus.$emit('reload-list')
        EventBus.$emit('close-modal', `maintenance-${this._uid}`)
      })
    },
    close(val) {
      EventBus.$emit('close-modal')
    }
  },
  computed: {},
  props: {
    request: null
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// EditInterventionRequestReveal.vue?6b2c9bc4